module.exports = __webpack_public_path__ + "img/jiandingbao.e6b8feb7.webp";